module.exports = __webpack_public_path__ + "static/media/fontawesome-webfont3e6e.6878d55e.svg";